module.exports = __webpack_public_path__ + "static/img/image3.b068f583.png";